import { Component, HostListener, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subject, Subscription, takeUntil } from "rxjs";
import { HomeService } from "src/app/feature/user/services/home/home.service";
import { CommonService } from "src/app/shared/services/common/common.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public currentYear: any;
  private languageSubscription: Subscription;
  // private currentLang: string = 'sv';
  private currentLang: string;
  public countryData: any;
  public helpfulLinksList: Array<any>;
  public serverError = false;
  private unsubscribe$ = new Subject();
  isLandingPage: any;

  constructor(private commonService: CommonService, private translateService: TranslateService, private router: Router, private homeService: HomeService) {}

  ngOnInit(): void {
    this.isLandingPage = this.router.url === '/' || this.router.url === '/landing';
    this.commonService.language$.subscribe((res) => {
      this.currentLang = res;
      this.getHelpfulLinksList(this.currentLang, 'Private');
    });
    this.getCurrentYear();
    this.countryData = this.commonService.loadCountryData();
  }

  public getCurrentYear(): void {
    this.currentYear = new Date().getFullYear();
  }

  reloadFooterOnNavigation(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.reloadFooter();
        }, 0);
      }
    });
  }

    // public getHomeDataTask (lang?: string, userType?: any): void {
    //   this.homeService.getHomeData(lang, userType)
    //     .pipe(takeUntil(this.unsubscribe$))
    //     .subscribe((resp) => {
    //       if (resp) {
    //         this.helpfulLinksList = resp?.helpfulLinksList[0]?.Channel_List;
    //       }
    //     },
    //       (err) => {
    //         if (err?.error?.StatusCode === "500") {
    //           this.serverError = true;
    //         }
    //       });
    // }
    public getHelpfulLinksList (lang?: string, userType?:string): void {		 
		this.homeService.getHomeData(lang, userType)
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe((resp) => {
		  if (resp) {
			this.helpfulLinksList = (resp?.helpfulLinksList) ? resp?.helpfulLinksList[0]?.Channel_List : [];
		  }
		},
		  (err) => {
			if (err?.error?.StatusCode === "500") {
			  this.serverError = true;
			}
		  });
	}

  reloadFooter(): void {
    const hasVerticalScrollbar = this.hasVerticalScrollbar();
    const footer = document.getElementById('theFooter');
    if (footer) {
      if (hasVerticalScrollbar) {
        footer.classList.remove('fixed-footer');
        footer.classList.add('footer');
      } else {
        footer.classList.remove('footer');
        footer.classList.add('fixed-footer');
      }
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.reloadFooter();
  }
  
  private hasVerticalScrollbar(): boolean {
    return document.body.scrollHeight > window.innerHeight;
  }
}

